import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CartSidebarComponent } from './components/cart-sidebar/cart-sidebar.component';
import { BaseItemComponent } from './components/items/base-item/base-item.component';
import { HotelItemComponent } from './components/items/hotel-item/hotel-item.component';
import { ParkItemComponent } from './components/items/park-item/park-item.component';
import { TransportItemComponent } from './components/items/transport-item/transport-item.component';
import { ExperienceItemComponent } from './components/items/experience-item/experience-item.component';
import { TicketItemComponent } from './components/items/ticket-item/ticket-item.component';
import { RentACarItemComponent } from './components/items/rent-a-car-item/rent-a-car-item.component';
import { InsuranceItemComponent } from './components/items/insurance-item/insurance-item.component';
import { FlightItemComponent } from './components/items/flight-item/flight-item.component';
import { BoatItemComponent } from './components/items/boat-item/boat-item.component';
import { CurrencyConverterPurePipe } from '../currency-converter-pure.pipe';
import { TooltipConvertAmountModule } from '../tooltip-convert-amount/tooltip-convert-amount.module';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TooltipConvertAmountModule,
    // TooltipModule.forRoot() ya se llama una vez en AppModule — acá solo
    // hace falta importarlo (sin forRoot) para que el directive [tooltip]
    // funcione en los templates de este módulo (usado en flight-item para
    // explicar cada ícono de la fila "Incluye").
    TooltipModule,
  ],
  declarations: [
    CartSidebarComponent,
    BaseItemComponent,
    HotelItemComponent,
    ParkItemComponent,
    TransportItemComponent,
    ExperienceItemComponent,
    TicketItemComponent,
    RentACarItemComponent,
    InsuranceItemComponent,
    FlightItemComponent,
    BoatItemComponent,
  ],
  exports: [
    CartSidebarComponent,
    HotelItemComponent,
    ParkItemComponent,
    TransportItemComponent,
    ExperienceItemComponent,
    TicketItemComponent,
    RentACarItemComponent,
    InsuranceItemComponent,
    FlightItemComponent,
    BoatItemComponent
  ],
  providers: [
 CurrencyConverterPurePipe]
})
export class CartModule { }
